/**
 * Simple logger utility for the SDK
 * Based on the Phantasy client app logger
 */

export interface Logger {
  debug(...args: unknown[]): void;
  info(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
}

export function createLogger(namespace: string): Logger {
  const prefix = `[Phantasy-SDK:${namespace}]`;

  return {
    debug: (...args: unknown[]) => {
      if (process.env.NODE_ENV === "development") {
        console.debug(prefix, ...args);
      }
    },
    info: (...args: unknown[]) => {
      console.info(prefix, ...args);
    },
    warn: (...args: unknown[]) => {
      console.warn(prefix, ...args);
    },
    error: (...args: unknown[]) => {
      console.error(prefix, ...args);
    },
  };
}
